var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"NotifyLayout"}},[_c('BANotify',{ref:"BAnotify",on:{"openDisasterDialog":_vm.openDisasterDialog}})],1),(_vm.disasterDialogVisible)?_c('DisasterDialog',{attrs:{"disaster-alert-data":_vm.disasterAlertData},on:{"close":_vm.closeDisasterDialog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }